import styled from 'styled-components';
import PollDetails from 'src/modules/community/poll/pollDetails';
import PollAnswers from 'src/modules/community/poll/pollAnswers';
export default function Poll() {
  return <PollContainer data-sentry-element="PollContainer" data-sentry-component="Poll" data-sentry-source-file="poll.tsx">
      <PollDetails data-sentry-element="PollDetails" data-sentry-source-file="poll.tsx" />
      <PollAnswers data-sentry-element="PollAnswers" data-sentry-source-file="poll.tsx" />
    </PollContainer>;
}
const PollContainer = styled.div`
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: ${({
  theme
}) => theme.greyLine};
`;